import React from "react";
import PropTypes from "prop-types";
import { Field, Control, Icon, Select } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { COUNTRIES } from "../../utils";

function CountrySelect({ value, onChange, size }) {
  return (
    <Field>
      <Control expanded iconLeft>
        <Select.Container fullwidth size={size}>
          <Select name="Country" value={value} onChange={onChange}>
            <Select.Option value="">Country</Select.Option>
            {Object.keys(COUNTRIES).map(key => (
              <Select.Option key={key} value={key}>
                {COUNTRIES[key]}
              </Select.Option>
            ))}
          </Select>
        </Select.Container>
        <Icon align="left">
          <FontAwesomeIcon icon="flag" />
        </Icon>
      </Control>
    </Field>
  );
}

CountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string
};

CountrySelect.defaultProps = {
  value: "",
  size: ""
};
export default CountrySelect;
